import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2, XCircle } from 'lucide-react';
export const WhoIsItForSection = () => {
  const isFor = ['Hispanos en USA con un puntaje de crédito menor a 620 puntos.', 'Familias que necesitan comprar un auto o casa pronto y no califican.', 'Personas con ITIN o SSN que se sienten perseguidas por agencias de cobranza.', 'Inmigrantes que quieren establecer un crédito sólido sin caer en estafas.'];
  const notFor = ['Personas que buscan hacer fraude o borrar deudas legítimas de las que no quieren hacerse cargo.', 'Quienes no están dispuestos a imprimir cartas y llevarlas al correo postal.', 'Quienes esperan que su crédito suba 200 puntos en 24 horas sin mover un dedo.'];
  return <SectionWrapper bg="bg-navy-800" data-id="element-133">
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-134">
        {/* Para quién ES */}
        <div className="bg-navy-900/80 p-8 rounded-2xl border-t-4 border-green-500 shadow-xl" data-id="element-135">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-136">
            <span className="bg-green-500/20 p-2 rounded-full" data-id="element-137">
              <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-138" />
            </span>
            Para quién <span className="text-green-400" data-id="element-139">SÍ ES</span>
          </h3>
          <ul className="space-y-6" data-id="element-140">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-141">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-142" />
                <span className="text-gray-300 text-lg" data-id="element-143">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Para quién NO ES */}
        <div className="bg-navy-900/80 p-8 rounded-2xl border-t-4 border-red-500 shadow-xl opacity-90" data-id="element-144">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-145">
            <span className="bg-red-500/20 p-2 rounded-full" data-id="element-146">
              <XCircle className="w-6 h-6 text-red-500" data-id="element-147" />
            </span>
            Para quién <span className="text-red-400" data-id="element-148">NO ES</span>
          </h3>
          <ul className="space-y-6" data-id="element-149">
            {notFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-150">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-151" />
                <span className="text-gray-400 text-lg" data-id="element-152">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </SectionWrapper>;
};